import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

import RpMUIDialog from "@/components/modals/RpMUIModal";
import PermissionsNoticeBox from "@/components/permissions/PermissionsNoticeBox";

import { USER_MANAGEMENT_PERMISSION_NOTICE } from "../constants/userManagementConstants";
import UserManagementModalHeader from "./UserManagementModalHeader";

const UserPermissionsModal = ({ open, onClose }) => (
  <RpMUIDialog open={open} onClose={onClose} maxWidth="sm">
    <Box sx={{ px: { xs: 1, sm: 1.5 }, pt: 1, pb: 2 }}>
      <UserManagementModalHeader title="Users Permission" onClose={onClose} />

      <Typography className="mb-3 p-1" variant="body2">
        Users you invite can manage campaigns, media plans, payments, reporting,
        and other account settings based on your current access level.
      </Typography>

      <PermissionsNoticeBox
        permissions={USER_MANAGEMENT_PERMISSION_NOTICE.permissions}
        variant="plain"
      />
    </Box>
  </RpMUIDialog>
);

UserPermissionsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UserPermissionsModal;
